export default __webpack_public_path__ + "static/DSC_0371-8550063bb483eef0a07ee01d9909ff42.jpg";